import React, {Fragment, useState} from 'react'
import {useParams} from 'react-router-dom'
import {isEmpty} from 'lodash'
import {capitalize} from 'admin/lib/format'
import useAccount from 'admin/hooks/useAccount'
import useDocument from 'admin/hooks/useDocument'
import Statement from 'admin/components/Statement'
import Breadcrumbs from 'admin/components/shared/Breadcrumbs'
import useBoolState from 'admin/hooks/useBoolState'
import Flash from 'admin/components/shared/Flash'
import Edit from './Edit'
import Show from './Show'
import Confirmation from '../Confirmation'

export default () => {
  const {organisationID, accountID} = useParams()
  const [editing, setEditing] = useState(false)
  const {account, errors, update, recalculate} = useAccount(organisationID, accountID)
  const [showConfirmArchive, setConfirmArchive, toggleConfirmArchive] = useBoolState()

  useDocument({title: account.displayName})

  const handleEdit = () => setEditing(true)
  const handleCancel = () => setEditing(false)

  const handleUpdate = changes => {
    update(changes, () => setEditing(false))
  }

  if (isEmpty(account)) return null

  const breadcrumbs = (
    <Breadcrumbs
      breadcrumbs={[
        {
          path: `/orgs/${organisationID}/accounts/${account.state}`,
          label: `Manage ${account.state} accounts`
        }
      ]}>
      <h3 className='title'>{account.displayName}</h3>
    </Breadcrumbs>
  )

  return (
    <Fragment>
      <Flash />

      {showConfirmArchive && (
        <Confirmation
          confirm='Repeating invoices will end today'
          onConfirm={() => update({state: 'archived'})}
          onClose={toggleConfirmArchive}
        />
      )}

      <div id='admin_account'>
        {account.state !== 'active' ? (
          <section
            className={`section py-3 ${
              account.state === 'draft' ? 'has-background-info' : 'has-background-grey-dark'
            }`}>
            <div className='container has-text-weight-semibold has-text-white-bis is-flex is-align-items-center'>
              <span style={{marginRight: 'auto'}}>{capitalize(account.state)}</span>
              {account.state === 'draft' ? (
                <button onClick={() => update({state: 'active'})} className='button is-small is-dark'>
                  Activate
                </button>
              ) : account.state === 'archived' ? (
                <button onClick={() => update({state: 'active'})} className='button is-small is-dark'>
                  Unarchive
                </button>
              ) : null}
            </div>
          </section>
        ) : null}

        <section className='section overview'>
          <div className='container'>
            {editing ? (
              <Edit
                breadcrumbs={breadcrumbs}
                account={account}
                errors={errors}
                onCancel={handleCancel}
                onSave={handleUpdate}
              />
            ) : (
              <Show
                breadcrumbs={breadcrumbs}
                account={account}
                onEdit={handleEdit}
                onArchive={toggleConfirmArchive}
                onRecalculate={() => recalculate({accountIds: [accountID]})}
              />
            )}
          </div>
        </section>
      </div>

      <Statement />
    </Fragment>
  )
}
